import React from "react";
import UpdateShortCode from "./UpdateShortCode";

export function UShortCode(props) {
    return <UpdateShortCode {...props} />
}
